import React, { Fragment, useState } from 'react'
import times from '@src/images/logos/mass-media/times'
import people from '@src/images/logos/mass-media/people'
import tintuk from '@src/images/logos/mass-media/tintuk'
import exame from '@src/images/logos/mass-media/exame'
import rusbase from '@src/images/logos/mass-media/rusbase'
import china from '@src/images/logos/mass-media/000'
import india from '@src/images/logos/mass-media/india.svg'
import josh from '@src/images/logos/mass-media/josh'

const MassMedia = (props) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(true);
  }

  return (
    <section className="section mass-media" id="massMedia">
      <h1 className="plate-heading plate-heading--left">
        { I18n.t('landing.about_us') }
      </h1>

      <div className="grid grid--xl-3">
        <a href="https://timesofindia.indiatimes.com/home/education/news/international-competition-in-mathematics-bricsmath-com-has-started/articleshow/79285244.cms" target="_blank" rel="noopener">
          <div className="grid grid--ng grid--md-2--kv-reverse">
            <div className="mass-media__logo mt-gutter-m">
              <img src={times} width="151" />
            </div>
            <div>
              <div className="f--default f--md mt-gutter-s">
                International competition in mathematics, BRICSMATH.COM+, has started
              </div>
              <div className="f--muted f--md mt-gutter-s">
                Nov 19, 2020, 16:41 IST
              </div>
            </div>
          </div>
        </a>

        <a href="http://world.people.com.cn/n1/2020/1119/c1002-31936547.html" target="_blank" rel="noopener">
          <div className="grid grid--ng grid--md-2--kv-reverse">
            <div className="mass-media__logo mt-gutter-m">
              <img src={people} width="107" />
            </div>
            <div>
              <div className="f--default f--md mt-gutter-s">
                “金砖+”国际数学竞赛举行 中小学生可随时在线报名答题
              </div>
              <div className="f--muted f--md mt-gutter-s">
                2020年11月19日08:33 06:27
              </div>
            </div>
          </div>
        </a>

        <a href="https://baotintuc.vn/giao-duc/olympic-toan-hoc-truc-tuyen-quoc-te-co-viet-nam-tham-gia-se-bat-dau-tu-ngay-1611-20201031061935902.htm" target="_blank" rel="noopener">
          <div className="grid grid--ng grid--md-2--kv-reverse">
            <div className="mass-media__logo mt-gutter-m">
              <img src={tintuk} width="88" />
            </div>
            <div>
              <div className="f--default f--md mt-gutter-s">
                Olympic toán học trực tuyến quốc tế có Việt Nam tham gia sẽ bắt đầu từ ngày 16/11
              </div>
              <div className="f--muted f--md mt-gutter-s">
                Thứ Bảy, 31/10/2020
              </div>
            </div>
          </div>
        </a>

        <a href="https://www.jagranjosh.com/news/bricsmath-to-be-inaugurated-at-the-brics-summit-in-brazil-on-13th-november-2019-152200" target="_blank" rel="noopener">
          <div className="grid grid--ng grid--md-2--kv-reverse">
            <div className="mass-media__logo mt-gutter-m">
              <img src={josh} width="114" />
            </div>
            <div>
              <div className="f--default f--md mt-gutter-s">
                BRICSMATH to be inaugurated at the BRICS summit in Brazil on 13th November 2019
              </div>
              <div className="f--muted f--md mt-gutter-s">
                NOV 8, 2019 15:59&nbsp;IST
              </div>
            </div>
          </div>
        </a>

        {isClicked ? (
          <Fragment>
            <a href="https://edu.163.com/19/1111/16/ETNCB0610029985J.html" target="_blank" rel="noopener">
              <div className="grid grid--ng grid--md-2--kv-reverse">
                <div className="mass-media__logo mt-gutter-m">
                  <img src={china} width="159" />
                </div>
                <div>
                  <div className="f--default f--md mt-gutter-s">
                    第三届金砖国家在线数学联欢节
                    <br />
                    即将拉开序幕
                  </div>
                  <div className="f--muted f--md mt-gutter-s">
                    2019-11-11 16:05:45
                  </div>
                </div>
              </div>
            </a>

            <a href="https://www.hindustantimes.com/education/cbse-to-hold-brics-math-online-competition-from-april-22-to-may-22/story-SstK9fs464w2wsztdMWX9K.html" target="_blank" rel="noopener">
              <div className="grid grid--ng grid--md-2--kv-reverse">
                <div className="mass-media__logo mt-gutter-m">
                  <img src={india} width="160" />
                </div>
                <div>
                  <div className="f--default f--md mt-gutter-s">
                    CBSE to hold BRICS math online competition from April 22 to May 22
                  </div>
                  <div className="f--muted f--md mt-gutter-s">
                    Apr 12, 2020, 09:18 IST
                  </div>
                </div>
              </div>
            </a>
            <a href="https://rb.ru/news/uchi-ru-maths-contest/" target="_blank" rel="noopener">
              <div className="grid grid--ng grid--md-2--kv-reverse">
                <div className="mass-media__logo mt-gutter-m">
                  <img src={rusbase} width="126"/>
                </div>
                <div>
                  <div className="f--default f--md mt-gutter-s">
                    Запустилась международная онлайн-олимпиада по&nbsp;математике на&nbsp;платформе Учи.ру
                  </div>
                  <div className="f--muted f--md mt-gutter-s">
                    16:16 15&nbsp;ноября 2019
                  </div>
                </div>
              </div>
            </a>
            <a href="https://exame.com/negocios/releases/nos-dias-da-cupula-dos-brics-foi-realizada-a-abertura-da-competicao-internacional-online-bricsmath-com/" target="_blank" rel="noopener">
              <div className="grid grid--ng grid--md-2--kv-reverse">
                <div className="mass-media__logo mt-gutter-m">
                  <img src={exame} width="110"/>
                </div>
                <div>
                  <div className="f--default f--md mt-gutter-s">
                    Nos dias da cúpula dos BRICS, foi realizada a abertura da competição internacional online BRICSMATH.COM
                  </div>
                  <div className="f--muted f--md mt-gutter-s">
                    26 nov 2019, 08h36
                  </div>
                </div>
              </div>
            </a>
          </Fragment>
        ) : null }
      </div>

      { isClicked ? null : (
          <button className="btn btn--light-blue f--upper mt-2" onClick={handleClick}>
            { I18n.t('landing.load_button') }
          </button>
        )
      }
    </section>
  )
}

export default MassMedia
